import { set } from 'lodash'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useLoader } from 'src/lib/contexts/LoaderContext'
import { postRequest } from 'src/lib/core/api-client'
import { useLocale } from 'src/lib/hooks/useLocal'
import { apiURI } from 'src/lib/utils/constants'

const RecipientEmailConfirmation = () => {
  const { t } = useLocale()
  const router = useRouter()
  const { token } = router.query

  const { setLoaderProperties } = useLoader()
  const [statusMessage, setStatusMessage] = useState<string | null>(null)

  useEffect(() => {
    if (!Boolean(token)) {
      router.replace('/auth/login')
    }

    const confirmInvitation = async () => {
      const payload = { invitation_token: token }
      setLoaderProperties({ isLoaderVisible: true, message: t('verifying_email') })
      try {
        const response = await postRequest('/merchant-invitation/accept', apiURI.AUTH_ENGINE, payload)
        const email = (response?.data as any)?.data?.oid
        setStatusMessage(t('email_confirmed_successfully'))
      } catch (error: any) {
        console.error(error)
        if (error?.data?.error?.code === 'GE_001') {
          setStatusMessage(t('email_already_verified'))
        } else {
          setStatusMessage(t('something_went_wrong'))
        }
      } finally {
        setLoaderProperties({ isLoaderVisible: false })
      }
    }

    if (token && typeof token === 'string') {
      confirmInvitation()
    }
  }, [token])

  return (
    <div className='flex flex-col items-center justify-center text-white'>
      <div className='p-6 shadow-md rounded-md text-center'>{statusMessage && <p>{statusMessage}</p>}</div>
    </div>
  )
}

export default RecipientEmailConfirmation
